import { ClassificationBackfillMode } from "@redotech/cockroachdb-codegen/tables/internal-ops/classification-backfill-mode";
import { ClassificationBackfillStatus } from "@redotech/cockroachdb-codegen/tables/internal-ops/classification-backfill-status";
import { ClassificationBackfillTarget } from "@redotech/cockroachdb-codegen/tables/internal-ops/classification-backfill-target";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const ClassificationBackfillRunSchema = z.object({
  id: z.string(),
  target: z.enum(ClassificationBackfillTarget),
  mode: z.enum(ClassificationBackfillMode),
  status: z.enum(ClassificationBackfillStatus),
  windowStart: z.date(),
  windowEnd: z.date(),
  concurrency: z.number().int(),
  eligible: z.number().int(),
  classified: z.number().int(),
  failed: z.number().int(),
  costUsd: z.number().nullable(),
  triggeredBy: z.string().nullable(),
  error: z.string().nullable(),
  createdAt: z.date(),
  startedAt: z.date().nullable(),
  finishedAt: z.date().nullable(),
});
export type ClassificationBackfillRun = z.infer<
  typeof ClassificationBackfillRunSchema
>;

export const getClassificationBackfillRuns = unaryRpc({
  name: "getClassificationBackfillRuns" as const,
  input: z.object({ limit: z.number().int().min(1).max(200).optional() }),
  output: z.object({ runs: z.array(ClassificationBackfillRunSchema) }),
});

export type GetClassificationBackfillRunsOutput = z.infer<
  typeof getClassificationBackfillRuns.output
>;
